/**
 * OS-1717 / OS-1719 — resultado real del email de una invitación (administradores de plataforma y
 * administrador inicial del tenant). Mismos estados que el API (`common/email`).
 */
export type InvitationEmailStatus = 'SENT' | 'FAILED' | 'PENDING' | 'NOT_CONFIGURED';

export interface InvitationEmailDelivery {
  status: InvitationEmailStatus;
  willRetry: boolean;
}

/** Por qué hace falta el link manual, según el resultado real del email. */
export function invitationFallbackReason(
  status: Exclude<InvitationEmailStatus, 'SENT'>,
  willRetry: boolean,
): string {
  switch (status) {
    case 'FAILED':
      return willRetry
        ? 'No se pudo enviar el email de invitación: el proveedor falló. Se reintentará solo, pero no hay confirmación.'
        : 'No se pudo enviar el email de invitación: el proveedor lo rechazó o no se pudo encolar.';
    case 'PENDING':
      return 'No pudimos confirmar el envío del email todavía. Puede llegar en unos minutos.';
    case 'NOT_CONFIGURED':
      return 'El envío de emails de invitación no está configurado en este ambiente.';
  }
}
